var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('baremetal-list',{attrs:{"hiddenFilterOptions":['host'],"id":_vm.id,"getParams":_vm.getParams}})}
var staticRenderFns = []

export { render, staticRenderFns }